import { Button } from 'ui';
import { useTranslations } from '../hooks/use-translations';

interface Props {
  id?: number;
  onClose: () => void;
  handleSubmit: () => void;
}

export default function CouponDrawerFooter({
  id,
  onClose,
  handleSubmit,
}: Props) {
  const t = useTranslations();

  return (
    <div className={'footer'}>
      <Button label={t('general.cancel')} onClick={onClose} />
      <Button
        label={t(id ? 'general.submit' : 'general.add')}
        type={'primary'}
        htmlType={'submit'}
        onClick={handleSubmit}
      />
    </div>
  );
}
